import type { ModuleFunction } from "~api/module";

/**
 * Wander tier info API foreground module
 */
const foreground: ModuleFunction<void> = () => {};

export default foreground;
